export const globalStylesDefaults = {
  style: {
    white: '#ffffff',
    searchBg: '#f8fcff'
  }
}



// WEBPACK FOOTER //
// ./src/constants/global-styles.constants.js